import React, { useContext, useEffect, useState } from "react";
import { AppContext } from "stores/AppStore";
import { useTranslation } from "react-i18next";
import { UserContext } from "stores/UserStore";
import { InspectionReportContext } from "stores/InspectionReportStore";
import { LoadingOverlay, FlexView, Icon } from "components/common";
import { Toggle } from "components/form";
import FiltersModal from "containers/inspection-report/FiltersModal";
import useInspectionReportFilters from "hooks/useInspectionReportFilters";
import InspectionReportTable from "containers/inspection-report/InspectionReportTable";
import FilterDisplay from "containers/inspection-report/FilterDisplay";

const InspectionReportPage = () => {
  const DEFAULT_URL = "inspection-report";
  const { t } = useTranslation();
  const { registryLog } = useContext(UserContext);
  const { setPageSubtitle } = useContext(AppContext);
 
  const {
    filters,
    showFinalized,
    setShowFinalized,
    getInspectionReportData,
    getSotList,
    getSotItemList,
    getRepostIdList,
    getReportVersionList,
    getInspectionDateList,
    getReportDateList,
    getProcessStatusList,    
    getWorkflowStatusList,    
    getNextWorkflowStatusList        
  } = useContext(InspectionReportContext);
  const [loading, setLoading] = useState(true);
  const [showModal, setShowModal] = useState(false);

  const filterOptions = useInspectionReportFilters();

  const toggleModal = () => setShowModal((currentState) => !currentState);

  useEffect(() => {
    setPageSubtitle(t("inspectionReport.pageTitle"));
  }, [setPageSubtitle, t]);

  useEffect(() => {
    //registryLogOld("Page In", DEFAULT_URL);
    registryLog(DEFAULT_URL, "navigation", "page_in");
    // setLoading(true);
    // getInspectionReportData(filters, showFinalized, 0)
    //   .then(() => {})
    //   .catch((e) => {
    //     console.debug(e);
    //   })
    //   .finally(() => setLoading(false));

      getSotList().then();
      getSotItemList().then();
      getRepostIdList().then();
      getReportVersionList().then();
      getInspectionDateList().then();
      getReportDateList().then();      

      getProcessStatusList().then();     
      getWorkflowStatusList().then();     
      getNextWorkflowStatusList().then();     

  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    console.log(filters);
    setLoading(true);

    getInspectionReportData(filters, showFinalized, 0)
    .then(() => {})
    .catch((e) => {
      console.debug(e);
    })
    .finally(() => setLoading(false));    


  }, [filters]); // eslint-disable-line react-hooks/exhaustive-deps

  const onRefreshClick = () => {
    //registryLogOld("Refresh", DEFAULT_URL);
    registryLog(DEFAULT_URL, "click", "refresh");
    setLoading(true);
    getInspectionReportData(filters, showFinalized, 0)
      .then(() => {})
      .catch((e) => {
        console.debug(e);
      })
      .finally(() => setLoading(false));

      getSotList().then();
      getSotItemList().then();
      getRepostIdList().then();
      getReportVersionList().then();
      getInspectionDateList().then();
      getReportDateList().then();      

      getProcessStatusList().then();     
      getWorkflowStatusList().then();     
      getNextWorkflowStatusList().then();           
  };

  const onToggleStatusChange = (status) => {
    //registryLogOld("Show Finalized " + (status ? " On" : "Off"), DEFAULT_URL);
    registryLog(
      DEFAULT_URL,
      "click",
      "show_finalized_" + (status ? " on" : "off")
    );
    setShowFinalized(status);
    setLoading(true);
    getInspectionReportData(filters, status, 0)
      .then(() => {})
      .catch((e) => {
        console.debug(e);
      })
      .finally(() => setLoading(false));
  };

  return (
    <FlexView flex="1" position="relative" alignSelf="stretch">
      <FlexView
        flexDirection="row"
        alignItems="center"
        justifyContent="flex-start"
        alignSelf="stretch"
        margin="16px"
      >
        <Icon name="report" width="30px" height="36px"></Icon>
        <FlexView
          fontSize="big"
          fontWeight="bold"
          color="gray"
          margin="0px 8px 0px 8px"
        >
          {t("inspectionReport.report")}
        </FlexView>
      </FlexView>

      <FlexView
        margin="10px 16px 4px"
        flexDirection="row"
        justifyContent="space-between"
        alignSelf="stretch"
      >
        <FilterDisplay options={filterOptions} onTagClick={toggleModal} />
        <FlexView
          flexDirection="row"
          alignItems="center"
          justifyContent="flex-end"
          flex="1"
        >
          <Toggle
            state={showFinalized}
            textOff={t("inspectionReport.show-to-finish")}
            textOn={t("inspectionReport.show-to-finish")}
            onChange={onToggleStatusChange}
            margin="0px 50px 0px 0px"
          ></Toggle>
          <Icon
            name="refresh"
            width="28px"
            height="28px"
            margin="0px 18px 0px 0px"
            tooltip={t("Refresh")}
            onClick={onRefreshClick}
          />
          <Icon
            name="filter"
            width="28px"
            height="28px"
            margin="0px 8px 0px 0px"
            tooltip={t("Filter")}
            onClick={toggleModal}
            color={Object.keys(filters).length === 0 ? "gray" : "success"}
          />
        </FlexView>
      </FlexView>
      <InspectionReportTable />
      <FiltersModal
        isOpen={showModal}
        onOutsideClick={toggleModal}
        options={filterOptions}
      />
      <LoadingOverlay visible={loading} />
    </FlexView>
  );
};

export default InspectionReportPage;
